import { Typography } from '@mui/material';
import React from 'react';
interface ContanierHeadingProps {
	name: string;
}
// const ContanierHeading = (name: string) => {
const ContanierHeading: React.FC<ContanierHeadingProps> = ({ name }) => (
	<Typography variant="h3" align="center" gutterBottom className="mb-2">
		{name}
	</Typography>
);

export default ContanierHeading;
